import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs';
import { ShellStatusService } from './shell-status.service';

/** Registered first and answers nothing: it only asks the top bar to refresh its counters after a successful prototype write. */
export const shellRefreshInterceptor: HttpInterceptorFn = (req, next) => {
  const status = inject(ShellStatusService);
  const isWrite = req.method !== 'GET' && req.url.includes('/api/proto/');
  return next(req).pipe(tap(event => {
    if (isWrite && event instanceof HttpResponse) status.requestRefresh();
  }));
};
